import { jsx as e, jsxs as u, Fragment as M } from "react/jsx-runtime";
import { c } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import * as h from "react";
import y, { useState as F, useRef as xe, useMemo as te, useEffect as q, useCallback as G, createContext as Ne, useContext as we } from "react";
import { X as oe } from "./x-5QknLR1d.js";
import { B as T } from "./Input-s7q1Bymv.js";
import { T as A } from "./Typography-DjQwU5Xn.js";
import { S as ut } from "./SafeHtml-D8NEcR7X.js";
import { C as Ce } from "./chevron-down-CAS1zUor.js";
import { C as ke } from "./check-CVfLJTWr.js";
import { B as ve, C as mt } from "./corner-down-left-BKmjNWYn.js";
import { c as ft, d as pt, e as ht, f as gt, C as bt } from "./DataGrid-C7ruANGS.js";
import { Tooltip as xt, Legend as vt, ResponsiveContainer as K, LineChart as De, CartesianGrid as se, XAxis as ne, YAxis as le, Line as Se, BarChart as yt, Bar as Nt, AreaChart as wt, Area as Ct, PieChart as kt, Pie as Dt, Cell as St } from "recharts";
import { c as At, P as $, b as z, h as Rt, u as ie, j as Et, d as Mt } from "./index-BwqhVa-H.js";
import { u as re } from "./index-DfspMmaX.js";
import { P as Ot, D as Pt } from "./index-B-Qjqgjx.js";
import { R as It, h as Lt, u as Tt, F as _t } from "./Combination-Te-rCbiT.js";
import { P as de } from "./index-Co1YE7s6.js";
import { S as zt, L as Ft } from "./search-B4CsPni9.js";
import { A as Kt, a as $t } from "./grid-3x3-D_KKntnt.js";
import { c as jt } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wt = [
  ["path", { d: "M4 5h16", key: "1tepv9" }],
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 19h16", key: "1djgab" }]
], ce = jt("menu", Wt);
var U = "Dialog", [Ae] = At(U), [Bt, C] = Ae(U), Re = (t) => {
  const {
    __scopeDialog: r,
    children: a,
    open: o,
    defaultOpen: n,
    onOpenChange: s,
    modal: i = !0
  } = t, l = h.useRef(null), d = h.useRef(null), [m, b] = Mt({
    prop: o,
    defaultProp: n ?? !1,
    onChange: s,
    caller: U
  });
  return /* @__PURE__ */ e(
    Bt,
    {
      scope: r,
      triggerRef: l,
      contentRef: d,
      contentId: re(),
      titleId: re(),
      descriptionId: re(),
      open: m,
      onOpenChange: b,
      onOpenToggle: h.useCallback(() => b((x) => !x), [b]),
      modal: i,
      children: a
    }
  );
};
Re.displayName = U;
var Ee = "DialogTrigger", Me = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, ...o } = t, n = C(Ee, a), s = ie(r, n.triggerRef);
    return /* @__PURE__ */ e(
      $.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": fe(n.open),
        ...o,
        ref: s,
        onClick: z(t.onClick, n.onOpenToggle)
      }
    );
  }
);
Me.displayName = Ee;
var ue = "DialogPortal", [Ht, Oe] = Ae(ue, {
  forceMount: void 0
}), Pe = (t) => {
  const { __scopeDialog: r, forceMount: a, children: o, container: n } = t, s = C(ue, r);
  return /* @__PURE__ */ e(Ht, { scope: r, forceMount: a, children: h.Children.map(o, (i) => /* @__PURE__ */ e(de, { present: a || s.open, children: /* @__PURE__ */ e(Ot, { asChild: !0, container: n, children: i }) })) });
};
Pe.displayName = ue;
var V = "DialogOverlay", Ie = h.forwardRef(
  (t, r) => {
    const a = Oe(V, t.__scopeDialog), { forceMount: o = a.forceMount, ...n } = t, s = C(V, t.__scopeDialog);
    return s.modal ? /* @__PURE__ */ e(de, { present: o || s.open, children: /* @__PURE__ */ e(Gt, { ...n, ref: r }) }) : null;
  }
);
Ie.displayName = V;
var qt = Rt("DialogOverlay.RemoveScroll"), Gt = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, ...o } = t, n = C(V, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ e(It, { as: qt, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ e(
        $.div,
        {
          "data-state": fe(n.open),
          ...o,
          ref: r,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), O = "DialogContent", Le = h.forwardRef(
  (t, r) => {
    const a = Oe(O, t.__scopeDialog), { forceMount: o = a.forceMount, ...n } = t, s = C(O, t.__scopeDialog);
    return /* @__PURE__ */ e(de, { present: o || s.open, children: s.modal ? /* @__PURE__ */ e(Vt, { ...n, ref: r }) : /* @__PURE__ */ e(Ut, { ...n, ref: r }) });
  }
);
Le.displayName = O;
var Vt = h.forwardRef(
  (t, r) => {
    const a = C(O, t.__scopeDialog), o = h.useRef(null), n = ie(r, a.contentRef, o);
    return h.useEffect(() => {
      const s = o.current;
      if (s) return Lt(s);
    }, []), /* @__PURE__ */ e(
      Te,
      {
        ...t,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: z(t.onCloseAutoFocus, (s) => {
          var i;
          s.preventDefault(), (i = a.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: z(t.onPointerDownOutside, (s) => {
          const i = s.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || l) && s.preventDefault();
        }),
        onFocusOutside: z(
          t.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), Ut = h.forwardRef(
  (t, r) => {
    const a = C(O, t.__scopeDialog), o = h.useRef(!1), n = h.useRef(!1);
    return /* @__PURE__ */ e(
      Te,
      {
        ...t,
        ref: r,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var i, l;
          (i = t.onCloseAutoFocus) == null || i.call(t, s), s.defaultPrevented || (o.current || (l = a.triggerRef.current) == null || l.focus(), s.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (s) => {
          var d, m;
          (d = t.onInteractOutside) == null || d.call(t, s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = s.target;
          ((m = a.triggerRef.current) == null ? void 0 : m.contains(i)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && n.current && s.preventDefault();
        }
      }
    );
  }
), Te = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: s, ...i } = t, l = C(O, a), d = h.useRef(null), m = ie(r, d);
    return Tt(), /* @__PURE__ */ u(M, { children: [
      /* @__PURE__ */ e(
        _t,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ e(
            Pt,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": fe(l.open),
              ...i,
              ref: m,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ u(M, { children: [
        /* @__PURE__ */ e(Xt, { titleId: l.titleId }),
        /* @__PURE__ */ e(Jt, { contentRef: d, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), me = "DialogTitle", _e = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, ...o } = t, n = C(me, a);
    return /* @__PURE__ */ e($.h2, { id: n.titleId, ...o, ref: r });
  }
);
_e.displayName = me;
var ze = "DialogDescription", Fe = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, ...o } = t, n = C(ze, a);
    return /* @__PURE__ */ e($.p, { id: n.descriptionId, ...o, ref: r });
  }
);
Fe.displayName = ze;
var Ke = "DialogClose", $e = h.forwardRef(
  (t, r) => {
    const { __scopeDialog: a, ...o } = t, n = C(Ke, a);
    return /* @__PURE__ */ e(
      $.button,
      {
        type: "button",
        ...o,
        ref: r,
        onClick: z(t.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
$e.displayName = Ke;
function fe(t) {
  return t ? "open" : "closed";
}
var je = "DialogTitleWarning", [Ir, We] = Et(je, {
  contentName: O,
  titleName: me,
  docsSlug: "dialog"
}), Xt = ({ titleId: t }) => {
  const r = We(je), a = `\`${r.contentName}\` requires a \`${r.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${r.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${r.docsSlug}`;
  return h.useEffect(() => {
    t && (document.getElementById(t) || console.error(a));
  }, [a, t]), null;
}, Yt = "DialogDescriptionWarning", Jt = ({ contentRef: t, descriptionId: r }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${We(Yt).contentName}}.`;
  return h.useEffect(() => {
    var s;
    const n = (s = t.current) == null ? void 0 : s.getAttribute("aria-describedby");
    r && n && (document.getElementById(r) || console.warn(o));
  }, [o, t, r]), null;
}, Be = Re, Lr = Me, He = Pe, X = Ie, Y = Le, J = _e, Z = Fe, qe = $e;
const Zt = ({ modal: t = !0, ...r }) => /* @__PURE__ */ e(Be, { modal: t, ...r }), Ge = He, pe = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  X,
  {
    ref: a,
    className: c(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...r
  }
));
pe.displayName = X.displayName;
const Ve = h.forwardRef(({ className: t, children: r, ...a }, o) => /* @__PURE__ */ e(Ge, { children: /* @__PURE__ */ u("div", { "aria-live": "polite", "aria-atomic": "true", children: [
  /* @__PURE__ */ e(pe, {}),
  /* @__PURE__ */ u(
    Y,
    {
      ref: o,
      className: c(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-[var(--density-gap)] border bg-[var(--ds-color-bg-surface-default)] p-[calc(var(--density-padding)*1.5)] shadow-elevation-3 duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-[var(--shape-radius-2xl)]",
        t
      ),
      role: "dialog",
      "aria-modal": "true",
      ...a,
      children: [
        r,
        /* @__PURE__ */ u(qe, { className: "absolute right-[var(--density-padding)] top-[var(--density-padding)] rounded-[var(--shape-radius-sm)] opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-[var(--ds-color-border-primary)] focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground rtl:left-[var(--density-padding)] rtl:right-auto", children: [
          /* @__PURE__ */ e(oe, { className: "h-4 w-4" }),
          /* @__PURE__ */ e("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }) }));
Ve.displayName = Y.displayName;
const Ue = ({
  className: t,
  ...r
}) => /* @__PURE__ */ e(
  "div",
  {
    className: c(
      "flex flex-col space-y-[calc(var(--density-gap)*0.75)] text-center sm:text-start",
      t
    ),
    ...r
  }
);
Ue.displayName = "DialogHeader";
const Xe = ({
  className: t,
  ...r
}) => /* @__PURE__ */ e(
  "div",
  {
    className: c(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-[var(--density-gap)]",
      t
    ),
    ...r
  }
);
Xe.displayName = "DialogFooter";
const Ye = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  J,
  {
    ref: a,
    className: c(
      "text-lg font-semibold leading-none tracking-tight",
      t
    ),
    ...r
  }
));
Ye.displayName = J.displayName;
const Je = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  Z,
  {
    ref: a,
    className: c("text-sm text-[var(--ds-color-fg-muted)]", t),
    ...r
  }
));
Je.displayName = Z.displayName;
const Qt = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl"
}, Tr = ({
  isOpen: t,
  onClose: r,
  title: a,
  description: o,
  children: n,
  footer: s,
  size: i = "md",
  closeOnOverlayClick: l = !0,
  className: d,
  portalContainer: m,
  ...b
}) => /* @__PURE__ */ e(Zt, { open: t, onOpenChange: (x) => !x && r(), children: /* @__PURE__ */ u(Ge, { container: m, children: [
  /* @__PURE__ */ e(pe, {}),
  /* @__PURE__ */ u(
    Ve,
    {
      className: c(Qt[i], d),
      onPointerDownOutside: (x) => {
        l || x.preventDefault();
      },
      ...b,
      children: [
        /* @__PURE__ */ u(Ue, { children: [
          /* @__PURE__ */ e(Ye, { children: a }),
          o && /* @__PURE__ */ e(Je, { children: o })
        ] }),
        /* @__PURE__ */ e("div", { className: "mt-4", children: n }),
        s && /* @__PURE__ */ e(Xe, { className: "mt-6", children: s })
      ]
    }
  )
] }) }), Ze = ({
  trigger: t,
  items: r,
  align: a = "start",
  className: o,
  ...n
}) => /* @__PURE__ */ u(ft, { children: [
  /* @__PURE__ */ e(pt, { asChild: !0, children: y.isValidElement(t) ? t : /* @__PURE__ */ e(T, { children: t }) }),
  /* @__PURE__ */ e(ht, { align: a, className: o, ...n, children: r.map((s) => /* @__PURE__ */ u(
    gt,
    {
      disabled: s.disabled,
      onClick: s.onClick,
      className: c(
        s.variant === "danger" && "text-destructive focus:text-destructive"
      ),
      children: [
        s.icon && /* @__PURE__ */ e("span", { className: "mr-3 h-5 w-5 text-muted-foreground group-hover:text-current", children: y.isValidElement(s.icon) ? y.cloneElement(s.icon, {
          // @ts-ignore
          size: 16,
          "aria-hidden": "true"
        }) : s.icon }),
        s.label
      ]
    },
    s.id
  )) })
] }), _r = ({
  title: t,
  description: r,
  breadcrumbs: a,
  actions: o = [],
  children: n,
  className: s,
  ...i
}) => /* @__PURE__ */ u(
  "div",
  {
    className: c(
      "flex flex-col gap-4 border-b border-border pb-5 md:flex-row md:items-center md:justify-between",
      s
    ),
    ...i,
    children: [
      /* @__PURE__ */ u("div", { className: "flex-1 min-w-0", children: [
        a && /* @__PURE__ */ e("div", { className: "mb-2", children: a }),
        /* @__PURE__ */ e(A, { variant: "h2", className: "text-foreground truncate", children: t }),
        r && /* @__PURE__ */ e(A, { variant: "body", className: "mt-1 text-muted-foreground", children: r })
      ] }),
      (o.length > 0 || n) && /* @__PURE__ */ u("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center", children: [
        o.map((l, d) => /* @__PURE__ */ e(
          T,
          {
            onClick: l.onClick,
            variant: l.variant || "secondary",
            leftIcon: l.icon,
            children: l.label
          },
          d
        )),
        n
      ] })
    ]
  }
), er = ({
  requiredPermission: t,
  action: r,
  resource: a,
  scope: o,
  check: n,
  can: s,
  children: i,
  fallback: l = null,
  behavior: d = "hide"
}) => {
  if (s && r && a ? s(r, a, o) : n && t ? n(t) : !1)
    return /* @__PURE__ */ e(M, { children: i });
  if (d === "disable") {
    if (y.isValidElement(i)) {
      const b = i.props || {};
      return y.cloneElement(i, {
        disabled: !0,
        "aria-disabled": !0,
        style: { ...b.style, pointerEvents: "none", opacity: 0.5 }
      });
    }
    return /* @__PURE__ */ e("div", { style: { pointerEvents: "none", opacity: 0.5 }, "aria-disabled": "true", children: i });
  }
  return /* @__PURE__ */ e(M, { children: l });
}, zr = ({
  html: t,
  className: r,
  size: a = "md",
  ...o
}) => /* @__PURE__ */ e(
  ut,
  {
    html: t,
    className: c(
      "prose prose-neutral dark:prose-invert max-w-none",
      {
        "prose-sm": a === "sm",
        "prose-base": a === "md",
        "prose-lg": a === "lg"
      },
      // Customizing prose styles to match design system tokens where possible
      "prose-headings:font-sans prose-headings:font-bold prose-headings:tracking-tight",
      "prose-p:font-sans prose-p:leading-relaxed",
      "prose-a:font-medium prose-a:text-primary prose-a:underline prose-a:decoration-primary/50 prose-a:underline-offset-2 hover:prose-a:decoration-primary",
      "prose-blockquote:border-l-primary prose-blockquote:bg-surface-secondary prose-blockquote:py-1 prose-blockquote:px-4 prose-blockquote:not-italic",
      "prose-code:bg-surface-secondary prose-code:rounded prose-code:px-1 prose-code:py-0.5 prose-code:before:content-none prose-code:after:content-none",
      "prose-pre:bg-surface-secondary prose-pre:text-foreground",
      r
    ),
    ...o
  }
), Fr = ({
  items: t,
  header: r,
  footer: a,
  isOpen: o = !0,
  onToggle: n,
  collapsible: s = !1,
  checkPermission: i,
  mobileOpen: l,
  onMobileOpenChange: d,
  hideMobileTrigger: m = !1,
  variant: b = "default",
  className: x,
  ...D
}) => {
  const [w, k] = y.useState(!1), S = l ?? w, P = (p) => {
    d ? d(p) : k(p);
  }, [I, L] = y.useState([]);
  y.useEffect(() => {
    const p = [], f = (v, g) => {
      v.forEach((E) => {
        E.isActive && g.length > 0 && p.push(...g), E.items && f(E.items, [...g, E.id]);
      });
    };
    f(t, []), L((v) => Array.from(/* @__PURE__ */ new Set([...v, ...p])));
  }, [t]);
  const R = () => P(!S), _ = (p) => {
    L(
      (f) => f.includes(p) ? f.filter((v) => v !== p) : [...f, p]
    );
  }, N = b === "floating", H = (p, f = 0) => {
    const v = /* @__PURE__ */ u("div", { className: "w-full", children: [
      /* @__PURE__ */ u(
        "button",
        {
          "aria-current": p.isActive ? "page" : void 0,
          onClick: (g) => {
            p.items && p.items.length > 0 ? (g.preventDefault(), _(p.id)) : (p.onClick && p.onClick(), p.href && typeof window < "u" && (window.location.href = p.href));
          },
          className: c(
            // Base styles with modern transitions
            "flex w-full items-center gap-3 text-sm font-medium transition-all duration-fast ease-smooth group relative",
            // 2026 Floating pill variant
            N ? [
              "px-3 py-2.5 rounded-xl",
              p.isActive ? "bg-primary/8 text-primary shadow-sm border border-primary/10" : "text-muted-foreground hover:bg-accent/60 hover:text-foreground"
            ] : [
              // Default variant (traditional)
              "px-3 py-2 rounded-lg",
              p.isActive ? "bg-accent text-primary" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
            ],
            // Nested depth padding
            f > 0 && (N ? "ml-3 pl-6" : "pl-9"),
            // Active indicator line for floating variant
            N && p.isActive && "before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-0.5 before:bg-primary before:rounded-full"
          ),
          children: [
            p.icon && /* @__PURE__ */ e("span", { className: c(
              "h-5 w-5 shrink-0 transition-colors duration-fast",
              p.isActive && "text-primary"
            ), children: p.icon }),
            /* @__PURE__ */ e("span", { className: "flex-1 text-left", children: p.label }),
            p.badge && /* @__PURE__ */ e("span", { className: c(
              "text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded-md",
              N ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"
            ), children: p.badge }),
            p.items && p.items.length > 0 && /* @__PURE__ */ e("span", { className: c(
              "shrink-0 transition-transform duration-normal",
              I.includes(p.id) && "rotate-180",
              p.isActive ? "text-primary" : "text-muted-foreground group-hover:text-foreground"
            ), children: /* @__PURE__ */ e(Ce, { className: "h-4 w-4" }) })
          ]
        }
      ),
      p.items && I.includes(p.id) && /* @__PURE__ */ e("div", { className: c(
        "mt-1 space-y-0.5 overflow-hidden",
        N && "border-l border-border-subtle ml-3"
      ), children: p.items.map((g) => H(g, f + 1)) })
    ] }, p.id);
    return p.requiredPermission && i ? /* @__PURE__ */ e(
      er,
      {
        requiredPermission: p.requiredPermission,
        check: i,
        behavior: "hide",
        children: v
      },
      p.id
    ) : v;
  };
  return /* @__PURE__ */ u(M, { children: [
    !m && /* @__PURE__ */ u("div", { className: c(
      "md:hidden flex items-center justify-between",
      N ? "p-4 bg-background/80 backdrop-blur-md border-b border-border-subtle" : "p-4 border-b border-border bg-background"
    ), children: [
      /* @__PURE__ */ e(A, { variant: "h4", className: "text-foreground font-semibold", children: "Menu" }),
      /* @__PURE__ */ e(
        T,
        {
          variant: "ghost",
          size: "sm",
          onClick: R,
          "aria-label": S ? "Close menu" : "Open menu",
          "aria-expanded": S,
          className: "hover:bg-accent/60",
          children: S ? /* @__PURE__ */ e(oe, { className: "h-5 w-5" }) : /* @__PURE__ */ e(ce, { className: "h-5 w-5" })
        }
      )
    ] }),
    /* @__PURE__ */ u(
      "aside",
      {
        className: c(
          "fixed inset-y-0 left-0 z-40 flex flex-col transition-transform duration-normal ease-smooth md:static md:translate-x-0",
          // Width and base styling
          N ? [
            "w-64 bg-surface-secondary/50 backdrop-blur-sm",
            // Floating sidebar has padding to create "detached" look
            "p-2"
          ] : [
            "w-64 border-r border-border bg-background"
          ],
          S ? "translate-x-0" : "-translate-x-full",
          x
        ),
        ...D,
        children: [
          r && /* @__PURE__ */ e("div", { className: c(
            N ? "p-3 mb-1" : "p-4 border-b border-border"
          ), children: r }),
          /* @__PURE__ */ e("nav", { className: c(
            "flex-1 overflow-y-auto",
            N ? "space-y-0.5 p-2" : "space-y-1 p-4"
          ), children: t.map((p) => H(p)) }),
          a && /* @__PURE__ */ e("div", { className: c(
            N ? "p-3 mt-1" : "p-4 border-t border-border"
          ), children: a })
        ]
      }
    ),
    S && /* @__PURE__ */ e(
      "div",
      {
        className: c(
          "fixed inset-0 z-30 md:hidden transition-opacity duration-normal",
          N ? "bg-background/60 backdrop-blur-sm" : "bg-foreground/50"
        ),
        onClick: () => P(!1)
      }
    )
  ] });
}, Kr = ({
  tenants: t,
  activeTenantId: r,
  onChange: a,
  className: o,
  placeholder: n = "Select Team"
}) => {
  const s = t.find((d) => d.id === r), i = t.map((d) => {
    const m = d.id === r;
    return {
      id: d.id,
      label: d.name,
      // If it's active, show Check, otherwise show Logo (or Building placeholder)
      icon: m ? /* @__PURE__ */ e(ke, { className: "h-4 w-4" }) : d.logo || /* @__PURE__ */ e(ve, { className: "h-4 w-4 text-muted-foreground" }),
      onClick: () => a(d.id)
    };
  }), l = /* @__PURE__ */ u(
    T,
    {
      variant: "outline",
      role: "combobox",
      "aria-expanded": !1,
      className: c("w-[200px] justify-between", o),
      children: [
        s ? /* @__PURE__ */ u("span", { className: "flex items-center gap-2 truncate", children: [
          s.logo ? /* @__PURE__ */ e("span", { className: "h-4 w-4 shrink-0 flex items-center justify-center", children: s.logo }) : /* @__PURE__ */ e(ve, { className: "h-4 w-4 shrink-0 text-muted-foreground" }),
          s.name
        ] }) : n,
        /* @__PURE__ */ e(bt, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
      ]
    }
  );
  return /* @__PURE__ */ e(
    Ze,
    {
      trigger: l,
      items: i,
      className: "w-[200px]"
    }
  );
}, $r = ({
  user: t,
  actions: r = [],
  className: a
}) => {
  const o = /* @__PURE__ */ u(T, { variant: "ghost", className: c("flex items-center gap-2 px-2 hover:bg-[var(--ds-color-bg-surface-hover)]", a), children: [
    /* @__PURE__ */ e("div", { className: "h-8 w-8 rounded-[var(--ds-radius-full)] bg-[var(--ds-color-bg-primary-subtle)] flex items-center justify-center text-[var(--ds-color-fg-primary)] overflow-hidden", children: t.avatarUrl ? /* @__PURE__ */ e("img", { src: t.avatarUrl, alt: t.name || t.email, className: "h-full w-full object-cover" }) : /* @__PURE__ */ e("span", { className: "font-bold text-xs", children: (t.name || t.email).slice(0, 2).toUpperCase() }) }),
    /* @__PURE__ */ u("div", { className: "flex flex-col items-start text-left hidden md:flex", children: [
      /* @__PURE__ */ e("span", { className: "text-sm font-medium leading-none", children: t.name || t.email }),
      t.role && /* @__PURE__ */ e("span", { className: "text-xs text-[var(--ds-color-fg-muted)]", children: t.role })
    ] }),
    /* @__PURE__ */ e(Ce, { className: "h-4 w-4 text-[var(--ds-color-fg-muted)]" })
  ] });
  return /* @__PURE__ */ e(
    Ze,
    {
      trigger: o,
      items: r,
      align: "end",
      className: "w-56"
    }
  );
}, ae = [
  "primary",
  "secondary",
  "success",
  "warning",
  "destructive",
  "accent"
], ye = (t, r = 0) => t ? ae.includes(t) ? `hsl(var(--ds-${t}))` : t : `hsl(var(--ds-${ae[r % ae.length]}))`, j = (t, r) => {
  const a = /* @__PURE__ */ new Map();
  return t.forEach((o, n) => {
    r && n < r.length ? a.set(o, ye(r[n], n)) : a.set(o, ye(void 0, n));
  }), a;
}, W = (t) => Array.isArray(t) ? t.map((r) => r.toString()).join(", ") : t.toString(), B = ({
  cursor: t = { fill: "hsl(var(--ds-muted) / 0.5)" },
  contentStyle: r = {
    backgroundColor: "hsl(var(--ds-popover))",
    borderColor: "hsl(var(--ds-border))",
    color: "hsl(var(--ds-popover-foreground))",
    borderRadius: "var(--ds-radius-md)",
    boxShadow: "var(--ds-shadow-md)"
  },
  formatter: a = W,
  ...o
}) => /* @__PURE__ */ e(
  xt,
  {
    cursor: t,
    contentStyle: r,
    formatter: a,
    content: ({ active: n, payload: s, label: i }) => !n || !(s != null && s.length) ? null : /* @__PURE__ */ u("div", { style: r, children: [
      i ? /* @__PURE__ */ e("p", { children: String(i) }) : null,
      /* @__PURE__ */ e("ul", { children: s.map((l) => /* @__PURE__ */ u("li", { children: [
        String(l.name ?? l.dataKey),
        ": ",
        String(a(Number(l.value), String(l.name ?? l.dataKey), l, s))
      ] }, `${l.name}-${l.dataKey}`)) })
    ] }),
    ...o
  }
), Q = (t) => /* @__PURE__ */ e(
  vt,
  {
    wrapperStyle: { paddingTop: "20px" },
    content: ({ payload: r }) => r != null && r.length ? /* @__PURE__ */ e("ul", { className: "flex flex-wrap gap-4", "aria-label": "Chart legend", children: r.map((a) => /* @__PURE__ */ e("li", { children: String(a.value) }, `${a.dataKey}-${a.value}`)) }) : null,
    ...t
  }
), jr = ({
  data: t,
  index: r,
  categories: a,
  colors: o,
  valueFormatter: n = W,
  className: s,
  h: i = 350,
  ariaLabel: l
}) => {
  const d = j(a, o);
  return /* @__PURE__ */ e("div", { className: c("w-full", s), style: { height: i }, role: "img", "aria-label": l, children: /* @__PURE__ */ e(K, { width: "100%", height: "100%", children: /* @__PURE__ */ u(De, { data: t, margin: { top: 20, right: 20, bottom: 20, left: 20 }, children: [
    /* @__PURE__ */ e(se, { strokeDasharray: "3 3", vertical: !1, stroke: "hsl(var(--ds-border))" }),
    /* @__PURE__ */ e(
      ne,
      {
        dataKey: r,
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1
      }
    ),
    /* @__PURE__ */ e(
      le,
      {
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1,
        tickFormatter: n
      }
    ),
    /* @__PURE__ */ e(B, { formatter: n }),
    /* @__PURE__ */ e(Q, {}),
    a.map((m) => /* @__PURE__ */ e(
      Se,
      {
        type: "monotone",
        dataKey: m,
        stroke: d.get(m),
        strokeWidth: 2,
        dot: !1,
        activeDot: { r: 6, strokeWidth: 0 }
      },
      m
    ))
  ] }) }) });
}, Wr = ({
  data: t,
  index: r,
  categories: a,
  colors: o,
  valueFormatter: n = W,
  className: s,
  h: i = 350,
  ariaLabel: l
}) => {
  const d = j(a, o);
  return /* @__PURE__ */ e("div", { className: c("w-full", s), style: { height: i }, role: "img", "aria-label": l, children: /* @__PURE__ */ e(K, { width: "100%", height: "100%", children: /* @__PURE__ */ u(yt, { data: t, margin: { top: 20, right: 20, bottom: 20, left: 20 }, children: [
    /* @__PURE__ */ e(se, { strokeDasharray: "3 3", vertical: !1, stroke: "hsl(var(--ds-border))" }),
    /* @__PURE__ */ e(
      ne,
      {
        dataKey: r,
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1
      }
    ),
    /* @__PURE__ */ e(
      le,
      {
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1,
        tickFormatter: n
      }
    ),
    /* @__PURE__ */ e(B, { formatter: n }),
    /* @__PURE__ */ e(Q, {}),
    a.map((m) => /* @__PURE__ */ e(
      Nt,
      {
        dataKey: m,
        fill: d.get(m),
        radius: [4, 4, 0, 0],
        maxBarSize: 50
      },
      m
    ))
  ] }) }) });
}, Br = ({
  data: t,
  index: r,
  categories: a,
  colors: o,
  valueFormatter: n = W,
  className: s,
  h: i = 350,
  ariaLabel: l
}) => {
  const d = j(a, o);
  return /* @__PURE__ */ e("div", { className: c("w-full", s), style: { height: i }, role: "img", "aria-label": l, children: /* @__PURE__ */ e(K, { width: "100%", height: "100%", children: /* @__PURE__ */ u(wt, { data: t, margin: { top: 20, right: 20, bottom: 20, left: 20 }, children: [
    /* @__PURE__ */ e("defs", { children: a.map((m) => /* @__PURE__ */ u("linearGradient", { id: `color-${m}`, x1: "0", y1: "0", x2: "0", y2: "1", children: [
      /* @__PURE__ */ e("stop", { offset: "5%", stopColor: d.get(m), stopOpacity: 0.3 }),
      /* @__PURE__ */ e("stop", { offset: "95%", stopColor: d.get(m), stopOpacity: 0 })
    ] }, m)) }),
    /* @__PURE__ */ e(se, { strokeDasharray: "3 3", vertical: !1, stroke: "hsl(var(--ds-border))" }),
    /* @__PURE__ */ e(
      ne,
      {
        dataKey: r,
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1
      }
    ),
    /* @__PURE__ */ e(
      le,
      {
        stroke: "hsl(var(--ds-muted-foreground))",
        fontSize: 12,
        tickLine: !1,
        axisLine: !1,
        tickFormatter: n
      }
    ),
    /* @__PURE__ */ e(B, { formatter: n }),
    /* @__PURE__ */ e(Q, {}),
    a.map((m) => /* @__PURE__ */ e(
      Ct,
      {
        type: "monotone",
        dataKey: m,
        stroke: d.get(m),
        fillOpacity: 1,
        fill: `url(#color-${m})`
      },
      m
    ))
  ] }) }) });
}, Hr = ({
  data: t,
  category: r,
  value: a,
  colors: o,
  valueFormatter: n = W,
  className: s,
  h: i = 350,
  ariaLabel: l
}) => {
  const d = Array.from(new Set(t.map((b) => b[r]))), m = j(d, o);
  return /* @__PURE__ */ e("div", { className: c("w-full", s), style: { height: i }, role: "img", "aria-label": l, children: /* @__PURE__ */ e(K, { width: "100%", height: "100%", children: /* @__PURE__ */ u(kt, { margin: { top: 20, right: 20, bottom: 20, left: 20 }, children: [
    /* @__PURE__ */ e(
      Dt,
      {
        data: t,
        cx: "50%",
        cy: "50%",
        innerRadius: 60,
        outerRadius: 80,
        paddingAngle: 5,
        dataKey: a,
        nameKey: r,
        children: t.map((b, x) => /* @__PURE__ */ e(
          St,
          {
            fill: m.get(b[r]),
            stroke: "hsl(var(--ds-background))",
            strokeWidth: 2
          },
          `cell-${x}`
        ))
      }
    ),
    /* @__PURE__ */ e(B, { formatter: n }),
    /* @__PURE__ */ e(
      Q,
      {
        verticalAlign: "bottom",
        height: 36,
        iconType: "circle"
      }
    )
  ] }) }) });
}, qr = ({
  data: t,
  index: r,
  categories: a,
  colors: o,
  className: n,
  h: s = 50,
  // Small default height
  ariaLabel: i
}) => {
  const l = j(a, o);
  return /* @__PURE__ */ e("div", { className: c("w-full", n), style: { height: s }, role: "img", "aria-label": i, children: /* @__PURE__ */ e(K, { width: "100%", height: "100%", children: /* @__PURE__ */ u(De, { data: t, children: [
    /* @__PURE__ */ e(
      B,
      {
        contentStyle: {
          backgroundColor: "hsl(var(--ds-popover))",
          borderColor: "hsl(var(--ds-border))",
          color: "hsl(var(--ds-popover-foreground))",
          borderRadius: "var(--ds-radius-md)",
          boxShadow: "var(--ds-shadow-md)",
          fontSize: "12px",
          padding: "4px 8px"
        }
      }
    ),
    a.map((d) => /* @__PURE__ */ e(
      Se,
      {
        type: "monotone",
        dataKey: d,
        stroke: l.get(d),
        strokeWidth: 2,
        dot: !1,
        activeDot: { r: 4, strokeWidth: 0 },
        isAnimationActive: !1
      },
      d
    ))
  ] }) }) });
}, Gr = ({
  title: t,
  metric: r,
  metricClassName: a,
  subtext: o,
  subtextClassName: n,
  icon: s,
  trend: i,
  trendColor: l,
  elevated: d = !0,
  // Default to premium elevated style
  children: m,
  className: b
}) => {
  const D = l ?? (i ? {
    up: "text-success",
    down: "text-destructive",
    neutral: "text-muted-foreground"
  }[i] : "text-muted-foreground"), w = l ?? (i === "up" ? "text-success" : i === "down" ? "text-destructive" : "text-muted-foreground");
  return /* @__PURE__ */ u("div", { className: c(
    "rounded-2xl border border-border bg-card p-5",
    d && "shadow-lg hover:shadow-xl transition-shadow duration-200",
    !d && "shadow-sm",
    b
  ), children: [
    /* @__PURE__ */ e("div", { className: "flex items-center justify-between space-x-4", children: /* @__PURE__ */ u("div", { className: "flex items-center space-x-2", children: [
      s && /* @__PURE__ */ e("div", { className: c(D), children: s }),
      /* @__PURE__ */ e("h3", { className: "text-sm font-medium text-muted-foreground", children: t })
    ] }) }),
    /* @__PURE__ */ u("div", { className: "mt-3 flex items-baseline space-x-2", children: [
      /* @__PURE__ */ e("p", { className: c("text-3xl font-semibold text-foreground tracking-tight", a), children: r }),
      o && /* @__PURE__ */ e("p", { className: c(
        "text-xs font-medium",
        i ? w : "text-muted-foreground",
        n
      ), children: o })
    ] }),
    m && /* @__PURE__ */ e("div", { className: "mt-4 h-10 w-full", children: m })
  ] });
}, tr = ({ modal: t = !1, ...r }) => /* @__PURE__ */ e(Be, { modal: t, ...r }), Qe = He, he = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  X,
  {
    className: c(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...r,
    ref: a
  }
));
he.displayName = X.displayName;
const et = h.forwardRef(({ side: t = "right", className: r, children: a, ...o }, n) => /* @__PURE__ */ e(Qe, { children: /* @__PURE__ */ u("div", { "aria-live": "polite", "aria-atomic": "true", children: [
  /* @__PURE__ */ e(he, {}),
  /* @__PURE__ */ u(
    Y,
    {
      ref: n,
      className: c(
        "fixed z-50 gap-[var(--density-gap)] bg-[var(--ds-color-bg-surface-default)] p-[calc(var(--density-padding)*1.5)] shadow-elevation-3 transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out duration-300",
        {
          top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
        }[t],
        r
      ),
      role: "complementary",
      ...o,
      children: [
        a,
        /* @__PURE__ */ u(qe, { className: "absolute right-[var(--density-padding)] top-[var(--density-padding)] rounded-[var(--shape-radius-sm)] opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-[var(--ds-color-border-primary)] focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary rtl:left-[var(--density-padding)] rtl:right-auto", children: [
          /* @__PURE__ */ e(oe, { className: "h-4 w-4" }),
          /* @__PURE__ */ e("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }) }));
et.displayName = Y.displayName;
const tt = ({
  className: t,
  ...r
}) => /* @__PURE__ */ e(
  "div",
  {
    className: c(
      "flex flex-col space-y-[var(--density-gap)] text-center sm:text-start",
      t
    ),
    ...r
  }
);
tt.displayName = "SheetHeader";
const rt = ({
  className: t,
  ...r
}) => /* @__PURE__ */ e(
  "div",
  {
    className: c(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-[var(--density-gap)]",
      t
    ),
    ...r
  }
);
rt.displayName = "SheetFooter";
const at = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  J,
  {
    ref: a,
    className: c("text-lg font-semibold text-[var(--ds-color-fg-default)]", t),
    ...r
  }
));
at.displayName = J.displayName;
const ot = h.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(
  Z,
  {
    ref: a,
    className: c("text-sm text-[var(--ds-color-fg-muted)]", t),
    ...r
  }
));
ot.displayName = Z.displayName;
const rr = {
  sm: "sm:max-w-sm",
  md: "sm:max-w-md",
  lg: "sm:max-w-lg",
  xl: "sm:max-w-xl",
  full: "w-screen"
}, Vr = ({
  isOpen: t,
  onClose: r,
  title: a,
  description: o,
  footer: n,
  children: s,
  position: i = "right",
  size: l = "md",
  className: d,
  ...m
}) => /* @__PURE__ */ e(tr, { open: t, onOpenChange: (b) => !b && r(), children: /* @__PURE__ */ u(Qe, { children: [
  /* @__PURE__ */ e(he, {}),
  /* @__PURE__ */ u(
    et,
    {
      side: i,
      className: c(rr[l], d),
      ...m,
      children: [
        (a || o) && /* @__PURE__ */ u(tt, { className: "mb-4", children: [
          a && /* @__PURE__ */ e(at, { children: a }),
          o && /* @__PURE__ */ e(ot, { children: o })
        ] }),
        /* @__PURE__ */ e("div", { className: "flex-1 overflow-y-auto", children: s }),
        n && /* @__PURE__ */ e(rt, { className: "mt-4 border-t pt-4", children: n })
      ]
    }
  )
] }) }), ar = (t, r) => {
  var i, l;
  const a = r.toLowerCase(), o = t.label.toLowerCase().includes(a), n = (i = t.description) == null ? void 0 : i.toLowerCase().includes(a), s = (l = t.keywords) == null ? void 0 : l.some((d) => d.toLowerCase().includes(a));
  return o || !!n || !!s;
}, Ur = ({
  open: t,
  onOpenChange: r,
  items: a,
  placeholder: o = "Search commands...",
  filter: n = ar,
  isLoading: s = !1,
  emptyMessage: i = "No results found.",
  onSelect: l,
  groupItems: d = !0,
  className: m,
  testId: b
}) => {
  const [x, D] = F(""), [w, k] = F(0), S = xe(null), P = xe(null), I = te(() => x.trim() ? a.filter((f) => n(f, x)) : a, [a, x, n]), L = te(() => {
    if (!d) return { "": I };
    const f = {};
    for (const v of I) {
      const g = v.group || "";
      f[g] || (f[g] = []), f[g].push(v);
    }
    return f;
  }, [I, d]), R = te(() => {
    const f = [];
    for (const v of Object.values(L))
      f.push(...v);
    return f;
  }, [L]);
  q(() => {
    t && (D(""), k(0), setTimeout(() => {
      var f;
      return (f = S.current) == null ? void 0 : f.focus();
    }, 0));
  }, [t]), q(() => {
    k(0);
  }, [x]), q(() => {
    if (P.current && R[w]) {
      const f = P.current.querySelector(`[data-index="${w}"]`);
      f == null || f.scrollIntoView({ block: "nearest" });
    }
  }, [w, R]);
  const _ = G((f) => {
    if (!f.disabled) {
      if (r(!1), f.href && typeof window < "u") {
        window.location.href = f.href;
        return;
      }
      f.onSelect && f.onSelect(), l && l(f);
    }
  }, [r, l]), N = G((f) => {
    switch (f.key) {
      case "ArrowDown":
        f.preventDefault(), k((g) => Math.min(g + 1, R.length - 1));
        break;
      case "ArrowUp":
        f.preventDefault(), k((g) => Math.max(g - 1, 0));
        break;
      case "Enter":
        f.preventDefault();
        const v = R[w];
        v && _(v);
        break;
      case "Escape":
        f.preventDefault(), r(!1);
        break;
    }
  }, [R, w, _, r]), H = G((f) => {
    f.target === f.currentTarget && r(!1);
  }, [r]);
  if (!t) return null;
  let p = 0;
  return /* @__PURE__ */ e(
    "div",
    {
      className: "fixed inset-0 z-50 flex items-start justify-center pt-[20vh] bg-black/50",
      onClick: H,
      "data-testid": b,
      children: /* @__PURE__ */ u(
        "div",
        {
          className: c(
            "w-full max-w-lg bg-popover border border-border rounded-[var(--ds-radius-lg)] shadow-lg overflow-hidden",
            m
          ),
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "Command palette",
          children: [
            /* @__PURE__ */ u("div", { className: "flex items-center gap-2 px-3 border-b border-border", children: [
              /* @__PURE__ */ e(zt, { className: "h-4 w-4 text-muted-foreground shrink-0" }),
              /* @__PURE__ */ e(
                "input",
                {
                  ref: S,
                  type: "text",
                  value: x,
                  onChange: (f) => D(f.target.value),
                  onKeyDown: N,
                  placeholder: o,
                  className: "flex-1 py-3 bg-transparent border-none outline-none text-sm text-foreground placeholder:text-muted-foreground",
                  autoComplete: "off",
                  autoCorrect: "off",
                  spellCheck: "false"
                }
              ),
              s && /* @__PURE__ */ e(Ft, { className: "h-4 w-4 text-muted-foreground animate-spin shrink-0" })
            ] }),
            /* @__PURE__ */ e(
              "div",
              {
                ref: P,
                className: "max-h-[300px] overflow-y-auto py-2",
                role: "listbox",
                children: R.length === 0 ? /* @__PURE__ */ e("div", { className: "px-4 py-8 text-center", children: /* @__PURE__ */ e(A, { variant: "body", className: "text-muted-foreground", children: i }) }) : Object.entries(L).map(([f, v]) => /* @__PURE__ */ u("div", { children: [
                  f && /* @__PURE__ */ e("div", { className: "px-3 py-1.5", children: /* @__PURE__ */ e(A, { variant: "small", className: "text-xs font-medium text-muted-foreground uppercase tracking-wider", children: f }) }),
                  v.map((g) => {
                    const E = p++, ee = E === w;
                    return /* @__PURE__ */ u(
                      "div",
                      {
                        "data-index": E,
                        role: "option",
                        "aria-selected": ee,
                        "aria-disabled": g.disabled,
                        className: c(
                          "flex items-center gap-3 px-3 py-2 mx-2 rounded-[var(--ds-radius-md)] cursor-pointer",
                          "transition-colors",
                          ee && "bg-accent",
                          g.disabled && "opacity-50 cursor-not-allowed",
                          !g.disabled && !ee && "hover:bg-accent/50"
                        ),
                        onClick: () => _(g),
                        onMouseEnter: () => k(E),
                        children: [
                          g.icon && /* @__PURE__ */ e("span", { className: "shrink-0 text-muted-foreground", children: g.icon }),
                          /* @__PURE__ */ u("div", { className: "flex-1 min-w-0", children: [
                            /* @__PURE__ */ e(A, { variant: "body", className: "truncate", children: g.label }),
                            g.description && /* @__PURE__ */ e(A, { variant: "small", className: "text-muted-foreground truncate", children: g.description })
                          ] }),
                          g.shortcut && /* @__PURE__ */ e("div", { className: "flex items-center gap-1", children: g.shortcut.map((dt, ct) => /* @__PURE__ */ e(
                            "kbd",
                            {
                              className: "px-1.5 py-0.5 text-xs font-mono bg-muted text-muted-foreground rounded border border-border",
                              children: dt
                            },
                            ct
                          )) })
                        ]
                      },
                      g.id
                    );
                  })
                ] }, f || "ungrouped"))
              }
            ),
            /* @__PURE__ */ u("div", { className: "flex items-center justify-between px-3 py-2 border-t border-border bg-muted/30 text-xs text-muted-foreground", children: [
              /* @__PURE__ */ u("div", { className: "flex items-center gap-4", children: [
                /* @__PURE__ */ u("span", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 font-mono bg-muted rounded border border-border", children: /* @__PURE__ */ e(Kt, { className: "h-3 w-3" }) }),
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 font-mono bg-muted rounded border border-border", children: /* @__PURE__ */ e($t, { className: "h-3 w-3" }) }),
                  /* @__PURE__ */ e("span", { children: "Navigate" })
                ] }),
                /* @__PURE__ */ u("span", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 font-mono bg-muted rounded border border-border", children: /* @__PURE__ */ e(mt, { className: "h-3 w-3" }) }),
                  /* @__PURE__ */ e("span", { children: "Select" })
                ] })
              ] }),
              /* @__PURE__ */ u("span", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 font-mono bg-muted rounded border border-border", children: "Esc" }),
                /* @__PURE__ */ e("span", { children: "Close" })
              ] })
            ] })
          ]
        }
      )
    }
  );
};
function Xr(t = {}) {
  const [r, a] = F(!1), { shortcut: o = { key: "k", metaKey: !0 } } = t;
  q(() => {
    const s = (i) => {
      const l = o.metaKey ? i.metaKey : !0, d = o.ctrlKey ? i.ctrlKey : !0;
      (l || d) && i.key.toLowerCase() === o.key.toLowerCase() && (i.preventDefault(), a((m) => !m));
    };
    return window.addEventListener("keydown", s), () => window.removeEventListener("keydown", s);
  }, [o]);
  const n = G(() => ({
    open: r,
    onOpenChange: a
  }), [r]);
  return { open: r, setOpen: a, getProps: n };
}
const Yr = ({
  steps: t,
  currentStepId: r,
  orientation: a = "horizontal",
  onStepClick: o,
  className: n,
  ...s
}) => {
  const i = t.findIndex((l) => l.id === r);
  return /* @__PURE__ */ e("nav", { "aria-label": "Progress", className: c(n), ...s, children: /* @__PURE__ */ e(
    "ol",
    {
      className: c(
        "flex",
        a === "vertical" ? "flex-col space-y-4" : "flex-row w-full"
      ),
      children: t.map((l, d) => {
        const m = d < i, b = l.id === r, x = o && (d < i || b);
        return /* @__PURE__ */ e(
          "li",
          {
            className: c(
              "relative flex items-center",
              a === "horizontal" && d !== t.length - 1 && "flex-1",
              x && "cursor-pointer"
            ),
            onClick: () => x && (o == null ? void 0 : o(l.id)),
            children: /* @__PURE__ */ u(
              "div",
              {
                className: c(
                  "group flex items-center",
                  a === "vertical" ? "w-full" : ""
                ),
                children: [
                  /* @__PURE__ */ u("span", { className: "flex items-center", children: [
                    /* @__PURE__ */ e(
                      "span",
                      {
                        className: c(
                          "flex h-8 w-8 items-center justify-center rounded-[var(--ds-radius-full)] border-2 transition-colors",
                          m ? "border-primary bg-primary" : b ? "border-primary" : "border-border"
                        ),
                        children: m ? /* @__PURE__ */ e(ke, { className: "h-5 w-5 text-primary-foreground" }) : /* @__PURE__ */ e(
                          "span",
                          {
                            className: c(
                              "text-sm font-medium",
                              b ? "text-primary" : "text-muted-foreground"
                            ),
                            children: d + 1
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ u("span", { className: c("ml-3 flex flex-col", a === "horizontal" && "min-w-max"), children: [
                      /* @__PURE__ */ e(
                        "span",
                        {
                          className: c(
                            "text-sm font-medium",
                            m || b ? "text-foreground" : "text-muted-foreground"
                          ),
                          children: l.label
                        }
                      ),
                      l.description && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: l.description })
                    ] })
                  ] }),
                  d !== t.length - 1 && /* @__PURE__ */ e(
                    "div",
                    {
                      className: c(
                        "hidden sm:block",
                        a === "horizontal" ? "ml-4 flex-1 border-t-2" : "ml-4 h-full border-l-2 absolute left-0 top-8",
                        m ? "border-primary" : "border-border"
                      ),
                      style: {
                        height: a === "vertical" ? "calc(100% - 2rem)" : void 0
                      }
                    }
                  )
                ]
              }
            )
          },
          l.id
        );
      })
    }
  ) });
}, Jr = ({
  sidebar: t,
  children: r,
  title: a,
  description: o,
  className: n,
  ...s
}) => /* @__PURE__ */ e("div", { className: c("flex min-h-screen flex-col bg-surface", n), ...s, children: /* @__PURE__ */ u("div", { className: "flex-1 space-y-8 p-8 md:flex", children: [
  /* @__PURE__ */ u("aside", { className: "-mx-4 md:w-1/4 md:px-4 lg:w-1/5", children: [
    a && /* @__PURE__ */ u("div", { className: "mb-4 px-4 md:px-0", children: [
      /* @__PURE__ */ e(A, { variant: "h3", className: "font-bold tracking-tight", children: a }),
      o && /* @__PURE__ */ e(A, { variant: "body", className: "text-muted-foreground", children: o })
    ] }),
    /* @__PURE__ */ e("nav", { className: "flex space-x-2 md:flex-col md:space-x-0 md:space-y-1 overflow-x-auto pb-2 md:pb-0", children: t })
  ] }),
  /* @__PURE__ */ e("div", { className: "flex-1 md:max-w-2xl lg:max-w-4xl", children: r })
] }) }), st = Ne(void 0), nt = () => {
  const t = we(st);
  if (!t)
    throw new Error("SidebarLayout components must be used within a SidebarLayout");
  return t;
}, ge = ({ children: t, className: r, ...a }) => {
  const [o, n] = F(!1);
  return /* @__PURE__ */ e(st.Provider, { value: { isSidebarOpen: o, setSidebarOpen: n }, children: /* @__PURE__ */ e("div", { className: c("min-h-screen bg-surface", r), ...a, children: t }) });
}, or = ({ children: t }) => {
  const { setSidebarOpen: r } = nt();
  return /* @__PURE__ */ e(M, { children: y.Children.map(t, (a) => y.isValidElement(a) ? y.cloneElement(a, {
    onMenuClick: () => r(!0),
    menuIcon: /* @__PURE__ */ e(ce, { className: "h-6 w-6" })
  }) : a) });
}, sr = ({ children: t }) => {
  const { isSidebarOpen: r, setSidebarOpen: a } = nt();
  return /* @__PURE__ */ e(M, { children: y.Children.map(t, (o) => y.isValidElement(o) ? y.cloneElement(o, {
    mobileOpen: r,
    onMobileOpenChange: a,
    hideMobileTrigger: !0
  }) : o) });
}, nr = ({ children: t, className: r }) => /* @__PURE__ */ e("main", { className: c("lg:pl-64 flex flex-col min-h-[calc(100vh-4rem)]", r), children: t });
ge.Header = or;
ge.Sidebar = sr;
ge.Content = nr;
const lt = Ne(void 0), it = () => {
  const t = we(lt);
  if (!t)
    throw new Error("AppShell components must be used within an AuthenticatedAppShell");
  return t;
}, be = ({ children: t, className: r, ...a }) => {
  const [o, n] = F(!1);
  return /* @__PURE__ */ e(lt.Provider, { value: { isMobileMenuOpen: o, setMobileMenuOpen: n }, children: /* @__PURE__ */ u("div", { className: c("flex h-screen w-full bg-background text-foreground overflow-hidden", r), ...a, children: [
    /* @__PURE__ */ e(
      "a",
      {
        href: "#main-content",
        className: "sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-background focus:text-foreground focus:outline-none focus:ring-2 focus:ring-ring",
        children: "Skip to main content"
      }
    ),
    t
  ] }) });
}, lr = ({ children: t, className: r }) => {
  const { isMobileMenuOpen: a, setMobileMenuOpen: o } = it();
  return /* @__PURE__ */ e(M, { children: y.Children.map(t, (n) => {
    if (y.isValidElement(n)) {
      const s = n.props;
      return y.cloneElement(n, {
        mobileOpen: a,
        onMobileOpenChange: o,
        hideMobileTrigger: !0,
        // We'll handle the trigger in the header
        className: c(s.className, r)
      });
    }
    return n;
  }) });
}, ir = ({ children: t, className: r, ...a }) => {
  const { setMobileMenuOpen: o } = it();
  return /* @__PURE__ */ u(
    "header",
    {
      className: c(
        "h-16 border-b border-border px-4 lg:px-6 flex items-center gap-4 bg-background sticky top-0 z-10 shrink-0",
        r
      ),
      ...a,
      children: [
        /* @__PURE__ */ e(
          T,
          {
            variant: "ghost",
            size: "sm",
            className: "lg:hidden shrink-0 p-2",
            onClick: () => o(!0),
            "aria-label": "Open menu",
            children: /* @__PURE__ */ e(ce, { className: "h-5 w-5" })
          }
        ),
        /* @__PURE__ */ e("div", { className: "flex-1 flex items-center justify-between min-w-0 gap-4", children: t })
      ]
    }
  );
}, dr = ({ children: t, className: r, ...a }) => /* @__PURE__ */ e(
  "main",
  {
    id: "main-content",
    tabIndex: -1,
    className: c("flex-1 overflow-auto bg-muted/5 p-4 lg:p-6 outline-none", r),
    ...a,
    children: t
  }
);
be.Sidebar = lr;
be.Header = ir;
be.Main = dr;
const cr = y.forwardRef(
  ({ className: t, children: r, testId: a, onCardMove: o, onDrop: n, onDragOver: s, ...i }, l) => /* @__PURE__ */ e(
    "div",
    {
      ref: l,
      "data-testid": a,
      role: "region",
      className: c(
        "flex h-full w-full overflow-x-auto overflow-y-hidden p-4 gap-4",
        "scrollbar-thin scrollbar-thumb-surface-overlay scrollbar-track-transparent",
        t
      ),
      onDragOver: (d) => {
        d.preventDefault(), s == null || s(d);
      },
      onDrop: (d) => {
        var b;
        if (n == null || n(d), !o) return;
        const m = d.dataTransfer.getData("application/json");
        if (m)
          try {
            const { cardId: x, sourceColumnId: D } = JSON.parse(m), k = (b = d.target.closest("[data-column-id]")) == null ? void 0 : b.getAttribute("data-column-id");
            x && D && k && o(x, D, k);
          } catch {
          }
      },
      ...i,
      children: r
    }
  )
);
cr.displayName = "KanbanBoard";
export {
  be as A,
  Z as B,
  jr as C,
  Tr as D,
  Lr as E,
  Be as F,
  Gr as K,
  X as O,
  _r as P,
  zr as R,
  Yr as S,
  Kr as T,
  $r as U,
  Ze as a,
  er as b,
  Fr as c,
  Wr as d,
  Br as e,
  Hr as f,
  B as g,
  Q as h,
  qr as i,
  Vr as j,
  Ur as k,
  Jr as l,
  ge as m,
  or as n,
  sr as o,
  nr as p,
  it as q,
  lr as r,
  ir as s,
  dr as t,
  Xr as u,
  cr as v,
  He as w,
  Y as x,
  qe as y,
  J as z
};
